import { Box, Typography, Grid } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { SVG } from 'components/Asset/SVG';
import { mapVehiclesAssets } from 'utils/helpers/mapAssetImage';
import type { productionAsset } from 'types/production.types';
import { convertToTwoDecimalPlaces } from 'components/Charts/Tooltip';
import { convertSeconds } from '../../AllFleet/utils';

import AssetItemChart from 'views/Production/AllFleet/components/AssetItem/AssetItemChart';
import useAppTheme from 'hooks/useAppTheme';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const AssetItem = ({
  data,
  selectedSource,
  aggregation,
}: {
  data: productionAsset;
  selectedSource: string;
  aggregation: string;
}) => {
  const { t } = useTranslation();
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Box
      sx={{
        height: '350px',
        backgroundColor: enableDarkTheme
          ? palette.paperBackground
          : palette.toolBarBackground,
        marginBottom: '15px',
        padding: '10px',
        borderRadius: '4px',
        border: `1px solid ${palette.cardBorderColor}`,
      }}
      data-attribute="assetItemBox"
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <SVG
          name={mapVehiclesAssets('haul_truck')}
          style={{
            fill: '#E2C171',
            height: '30px',
            width: '60px',
            paddingRight: '10px',
          }}
        />
        <Box>
          <Typography
            sx={{
              color: palette.textSecondary,
              fontSize: '13px',
            }}
          >
            {data?.bumper_id}
          </Typography>
          <Box
            sx={{
              display: 'flex',
            }}
          >
            {/* <PowerSettingsNewIcon
              sx={{
                color: data.device === 'aa' ? '#00C853' : '#E63946',
                marginRight: '8px',
                fontSize: '12px',
              }}
            /> */}
            <Typography
              sx={{
                fontSize: '10px',
                color: palette.textPrimary,
              }}
            >
              {data?.make} - {data?.model}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          marginTop: '10px',
        }}
      >
        <Grid
          container
          sx={{
            fontSize: '13px',
            color: palette.textSecondary,
          }}
        >
          <Grid item lg={6} sm={12} xs={12}>
            <Typography
              sx={{
                fontSize: '13px',
              }}
            >
              {t('production')}
            </Typography>
            <Typography
              sx={{
                marginTop: '5px',
                fontSize: '11px',
              }}
            >
              {convertToTwoDecimalPlaces(data?.max_load_sum?.toString())}
              {' Tons'}
            </Typography>
          </Grid>
          <Grid item lg={6} sm={12} xs={12}>
            <Typography
              sx={{
                fontSize: '13px',
              }}
            >
              {t('loads_day')}
            </Typography>

            <Typography
              sx={{
                marginTop: '5px',
                fontSize: '11px',
              }}
            >
              {convertToTwoDecimalPlaces(
                data?.avg_max_load_per_day?.toString()
              )}{' '}
              {t('tons_unit')}
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          sx={{
            fontSize: '13px',
            color: palette.textSecondary,
          }}
        >
          <Grid item lg={6} sm={12} xs={12}>
            <Typography
              sx={{
                marginTop: '10px',
                fontSize: '13px',
              }}
            >
              {t('avg_hauler_cycle_time')}
            </Typography>
            <Typography
              sx={{
                marginTop: '5px',
                fontSize: '11px',
              }}
            >
              {convertToTwoDecimalPlaces(
                convertSeconds(data?.avg_cycle_time).value.toString()
              )}{' '}
              {convertSeconds(data?.avg_cycle_time).unit}
            </Typography>
          </Grid>
          <Grid item lg={6} sm={12} xs={12}>
            <Typography
              sx={{
                marginTop: '10px',
                fontSize: '13px',
              }}
            >
              {t('pass_count_cycle')}
            </Typography>
            <Typography
              sx={{
                marginTop: '5px',
                fontSize: '11px',
              }}
            >
              {convertToTwoDecimalPlaces(data?.pass_count_cycle?.toString())}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <AssetItemChart
        data={data}
        selectedSource={selectedSource}
        height="180px"
        aggregation={aggregation}
      />
    </Box>
  );
};

export default AssetItem;
